import Vue from 'vue'
import Login from '@/views/login/Login.vue'
import { mapGetters } from 'vuex'
import { Dialog } from '@jdt/find'
import {
  formatCurrency,
  formatDate,
  formatRate,
  formatPhone,
  getProductCode,
  setProductCode,
  enumFilter,
} from '@/utils/index.js'
// import store from '@/store/index.js'
// const isMock = import.meta.env.MODE === 'mock'

const DialogConstructor = Vue.extend(Dialog)

Vue.mixin({
  data() {
    return {
      productCode: getProductCode() || '19001',
    }
  },
  watch: {
    productCode(val) {
      setProductCode(val)
    },
  },
  filters: { formatCurrency, formatDate, formatRate, formatPhone, enumFilter },
  computed: {
    ...mapGetters([
      'userInfo',
      'allProducts',
      'enumData',
      'enumMap',
      'config',
      'productInfo',
      'apiLoading',
      'pageLoading',
    ]),
    openedProducts() {
      return this.allProducts.filter(item => item.userProductState == 'OPENED')
    },
  },
  methods: {
    formatCurrency,
    formatDate,
    formatRate,
    formatPhone,
    enumFilter,
    getProductCode,
    openLogin(redirectUrl) {
      let loginVNode = <Login redirectUrl={redirectUrl}></Login>
      this.openDialog(loginVNode, { customClass: 'login-box' })
    },
    openDialog(vNode, options) {
      const map = {
        primary: { icon: 'info', color: 'primary' },
        success: { icon: 'success', color: 'success' },
        error: { icon: 'error', color: 'danger' },
        info: { icon: 'info', color: 'info' },
        warning: { icon: 'warning', color: 'warning' },
      }
      let instance = new DialogConstructor({
        el: document.createElement('div'),
        propsData: {
          width: '352px',
          visible: true,
          closeOnClickModal: false,
          ...options,
        },
        store: this.$store,
        router: this.$router,
      })
      vNode.componentOptions.listeners = {
        ...vNode.componentOptions.listeners,
        close: () => {
          instance.visible = false
        },
      }
      const hasTitle = options.type || options.contentTitle
      let contentNode = (
        <div>
          {hasTitle ? (
            <p class="flex leading-32">
              {options.type ? (
                <i
                  class={[
                    'text-3xl',
                    'mr-8',
                    `fin-icon-${map[options.type].icon}-solid`,
                    `text-${map[options.type].color}`,
                  ]}
                ></i>
              ) : null}
              <span class="text-base text-black text-opacity-85 font-bold">{options.contentTitle}</span>
            </p>
          ) : null}
          <div class={{ 'pl-40': hasTitle }}>{vNode}</div>
        </div>
      )

      instance.$on('close', () => (instance.visible = false))
      instance.$on('closed', () => instance.$el.parentNode.removeChild(instance.$el))
      instance.$slots.default = [contentNode]
      document.body.appendChild(instance.$el)
    },
    // 获取字典，已在router/index.js，写了一个全局的调用
    async getEnum(params = []) {
      await this.$store.dispatch('enum/getEnum', params)
    },
  },
})
